import { LoadingAnimation, withForm } from '@uag/react-core';
import { OnboardingRequestModel } from '@uag/welcome-shared/src/api/models';
import { useGetTermsAndConditions } from '@uag/welcome-shared/src/api/queries/terms-and-conditions/terms-and-conditions';
import { CompanyInformation } from '@uag/welcome-shared/src/components/company/ViewCompany/CompanyInformation';
import { clsx } from 'clsx';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router';

type Props = {
    request: OnboardingRequestModel;
    className?: string;
};

export const SignContractForm = withForm({
    // These values are only used for type-checking, and are not used at runtime
    // This allows you to `...formOpts` from `formOptions` without needing to redeclare the options
    props: {} as Props,
    defaultValues: {
        iAgreeTheTermsAndConditions: false,
        iHaveReadAndUnderstood: false,
    },
    render: ({ form, request }) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { t } = useTranslation();

        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: termsConditionsLink, isLoading: isTermsConditionsLinkLoading } = useGetTermsAndConditions({
            isoCountryCode: request.companyData.mainAddress?.countryConfiguration?.countryCode,
        });

        if (isTermsConditionsLinkLoading) {
            return <LoadingAnimation />;
        }

        return (
            <div className={clsx('gap-lg flex flex-col')}>
                <div className="gap-sm flex flex-col">
                    {t('companyDataSummary')}
                    <div className="border-border-disabled border">
                        <CompanyInformation mode="Frontend" request={request} />
                    </div>
                </div>
                <div>
                    <form.AppField name="iAgreeTheTermsAndConditions">
                        {(field) => (
                            <field.Checkbox
                                label={
                                    <>
                                        <Trans
                                            components={{
                                                a: (
                                                    <Link
                                                        className="link"
                                                        target="_blank"
                                                        to={termsConditionsLink?.data.uri ?? ''}
                                                    />
                                                ),
                                            }}
                                            i18nKey="termsAndConditionsLinkDescription"
                                        />
                                        <span className="text-text-alert">*</span>
                                    </>
                                }
                            />
                        )}
                    </form.AppField>

                    <form.AppField name="iHaveReadAndUnderstood">
                        {(field) => (
                            <field.Checkbox
                                label={
                                    <>
                                        <Trans
                                            components={{
                                                a: (
                                                    <Link
                                                        className="link"
                                                        target="_blank"
                                                        to={'https://doka.com/data-privacy'}
                                                    />
                                                ),
                                            }}
                                            i18nKey="privacyPolicyLinkDescription"
                                        />
                                        <span className="text-text-alert">*</span>
                                    </>
                                }
                                required
                            />
                        )}
                    </form.AppField>
                </div>
            </div>
        );
    },
});
